import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { EMoneyContactSyncSettings } from './EMoneyContactSyncSettings'

export const EMoneySpecificSettings = (): ClickNavigationSection[] => {
  return [{ id: 'contactSync', label: 'Contact Sync', content: () => <EMoneyContactSyncSettings /> }]
}
